import { ScreenSizes } from '@interfaces/index';
import { IStyles } from '@interfaces/styles';
import { useTheme } from '@mui/material';

export const useStyles = (): IStyles => {
  const { breakpoints } = useTheme();

  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      rowGap: '40px',
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        rowGap: '30px',
      },
      [breakpoints.down(ScreenSizes.Tablet)]: {
        rowGap: '20px',
      },
      [`@media screen and (orientation:landscape)
        and (max-device-height: 760px)
        and (max-device-width: 1180px)`]: {
        rowGap: '20px',
      },
    },
  };
};
